function Navigation() {
    let button = document.querySelector('[js-anchor-menutoggle]');
    let menu = document.querySelector('[js-anchor-menu]');

    button.onclick = function() {
        button.classList.toggle('is-active');
        menu.classList.toggle('is-active');
    }

}

// Export the navigation init function
export default Navigation;



// WEBPACK FOOTER //
// /Users/sandersturing/Sites/SD/open.test/frontend/source/utilities/navigation.js